import useMediaQuery from "@mui/material/useMediaQuery";
import { useRouter } from "next/router";
import React, { Fragment, useEffect, useState } from "react";
import Lottie from "react-lottie";
import { useDispatch, useSelector } from "react-redux";
import BellIconLottie from "../../../assets/lotties/job-alert/alert-bell.json";
import {
  updateJobAlertCreateDialog,
  updateJobAlertCreateDialogWithKeyword,
  updateVisitorJobAlertDialogDetails,
} from "../../../redux/actions/dialog_action";
import {
  getJobAlerts,
  updateJobAlertEmail,
} from "../../../redux/actions/job_action";
import { updateUserProfileDrawerIndex } from "../../../redux/actions/user_action";

import { useWindowScroll } from "@uidotdev/usehooks";
import {
  AlertTypography,
  CheckStyled,
  GlobalHireContainer,
  GlobalHireLink,
  GlobalHireTypography,
  GlobalIcon,
  GridStyled,
  IconButtonStyle,
  IconButtonStyled,
  InputAdornmentStyled,
  InputBaseStyled,
  InputStyled,
  JobAlertContainer,
  LoggedInAlertTypography,
  SendIconStyled,
  TextContainer,
  TextWrapper,
  UnsubcribeContainer,
  VisitorJobAlertContainer,
  WhiteButton,
} from "./styles";

function JobDetailsJobAlert(props) {
  const { job } = props;

  const [email, setEmail] = useState("");
  const [existed, setExisted] = useState(false);
  const [pauseLottie, setPauseLottie] = useState(true);
  const router = useRouter();
  const dispatch = useDispatch();

  const jobAlerts = useSelector((state) => state?.jobs?.jobAlerts);
  const reduxUser = useSelector((state) => state?.user?.user);

  const belowLg = useMediaQuery("(max-width: 1279px)");
  const belowTablet = useMediaQuery("(max-width: 767px)");

  // Check if user already created similar job alert
  useEffect(() => {
    dispatch(getJobAlerts());
  }, []);

  useEffect(() => {
    Array.isArray(jobAlerts) &&
      jobAlerts.length > 0 &&
      jobAlerts.map((alert) => {
        if (
          alert?.title?.toString().includes(job.title) ||
          alert?.title === job?.title
        ) {
          setExisted(true);
        }
      });
  }, [jobAlerts]);

  // Get Email Input
  const onInputUpdate = (event) => {
    setEmail(event.target.value);
    dispatch(
      updateVisitorJobAlertDialogDetails({
        email: event.target.value,
      })
    );
    dispatch(updateJobAlertEmail(event.currentTarget.value));
  };

  // When User is not logged in
  const createVisitorJobAlertHandler = () => {
    // dispatch(
    //   updateVisitorJobAlertDialogDetails({
    //     keyword: job?.title ?? "",
    //   })
    // );
    // dispatch(updateVisitorJobAlertDialogOrigin("single-job-page"));
    dispatch(
      updateJobAlertCreateDialogWithKeyword({
        keyword: job?.title ?? "",
        origin: "single-job-page",
      })
    );
    dispatch(updateJobAlertCreateDialog(true));
    // dispatch(updateShowJobAlertDialog(true));
  };

  // When User is logged in
  const createJobAlertHandler = () => {
    dispatch(
      updateJobAlertCreateDialogWithKeyword({
        keyword: job?.title ?? "",
        origin: "single-job-page",
      })
    ).then(() => {
      dispatch(updateJobAlertCreateDialog(true));
    });
  };

  const UnsubscribeHandler = () => {
    dispatch(updateUserProfileDrawerIndex(2));
    router.push("/profile#manage-job-alerts", undefined, { shallow: true });
  };

  const [{ y }, scrollTo] = useWindowScroll();

  function handleScroll() {
    const section = document.getElementById("job-work-arrangement");
    const headerOffset = 200;
    const elementPosition = section?.getBoundingClientRect().top;
    const offsetPosition = elementPosition + y - headerOffset;
    scrollTo({ top: offsetPosition, behavior: "smooth" });
  }

  return (
    <Fragment>
      {job.globalHirePreferences.rightToWorkOpenToSponsor ||
        job.globalHirePreferences.rightToWorkWorkVisaOrEmploymentPass ? (
        <GlobalHireContainer>
          <GlobalIcon />
          <GlobalHireTypography>
            <TextContainer>Open to international talents.</TextContainer> Full
            details
            <GlobalHireLink onClick={() => handleScroll()}>here</GlobalHireLink>
            .
          </GlobalHireTypography>
        </GlobalHireContainer>
      ) : reduxUser?.id === undefined ? (
        <VisitorJobAlertContainer
          container
          justifyContent="flex-start"
          alignItems="center"
          alignContent="center"
          onMouseEnter={() => {
            setPauseLottie(false);
          }}
          onMouseLeave={() => {
            setPauseLottie(true);
          }}
        >
          <GridStyled
            container
            flexWrap={"nowrap"}
            alignItems={"center"}
            justifyContent={"space-between"}
            columnGap={"5px"}
          >
            <Lottie
              options={{
                loop: true,
                autoplay: true,
                animationData: BellIconLottie,
              }}
              isStopped={pauseLottie}
              width={"35px"}
              height={"35px"}
            />

            <InputStyled>
              <InputBaseStyled
                placeholder={"Enter email for job updates"}
                onChange={onInputUpdate}
                endAdornment={
                  <InputAdornmentStyled position="end">
                    <IconButtonStyled onClick={createVisitorJobAlertHandler}>
                      <SendIconStyled />
                    </IconButtonStyled>
                  </InputAdornmentStyled>
                }
                onKeyDown={(event) => {
                  if (event.key === "Enter") {
                    createVisitorJobAlertHandler();
                  }
                }}
              />
            </InputStyled>
          </GridStyled>
        </VisitorJobAlertContainer>
      ) : existed && reduxUser?.id?.length > 1 ? (
        <UnsubcribeContainer
          container
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          flexWrap={"nowrap"}
        >
          <TextWrapper container alignItems="center" gap={"15px"}>
            <IconButtonStyle>
              <CheckStyled />
            </IconButtonStyle>
            <AlertTypography variant="body1_bold_L">
              Job Alert Created
            </AlertTypography>
          </TextWrapper>

          <WhiteButton onClick={UnsubscribeHandler}>Unsubscribe</WhiteButton>
        </UnsubcribeContainer>
      ) : (
        <JobAlertContainer
          container
          justifyContent="center"
          alignItems="center"
          onClick={createJobAlertHandler}
          onKeyDown={(event) => {
            if (event.key === "Enter") {
              createJobAlertHandler();
            }
          }}
          onMouseEnter={() => {
            setPauseLottie(false);
          }}
          onMouseLeave={() => {
            setPauseLottie(true);
          }}
          columnGap={"5px"}
        >
          <LoggedInAlertTypography variant="body1" maxWidth={"100%"}>
            Email me similar jobs
          </LoggedInAlertTypography>
          <Lottie
            options={{
              loop: true,
              autoplay: true,
              animationData: BellIconLottie,
            }}
            isStopped={pauseLottie}
            width={belowTablet ? "40px" : belowLg ? "32px" : "40px"}
            height={belowTablet ? "40px" : belowLg ? "32px" : "40px"}
            style={{
              margin: "0px",
            }}
          />
        </JobAlertContainer>
      )}
    </Fragment>
  );
}

export default JobDetailsJobAlert;
